import React from 'react';

// Line-art result-pill glyphs — cousins of the house combat-tag icons
// (Tabler-style 24-viewBox strokes, currentColor, round caps/joins). These are
// shown ONLY in the mobile full-page combat HUD (.dlm-stage), where they replace
// the "Damage dealt" / "Damage taken" word labels to free horizontal width for
// the enemy/boss HP bars. Everywhere else the icon is display:none (see
// .batch-result-pill-icon base rule), so the desktop combat surface is unchanged.

const svgProps = (size, className) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  ...(className ? { className } : null),
});

// Damage dealt — an outgoing strike (sword).
export const SwordGlyph = ({ size = 15, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M20 4v5l-9 7l-4 4l-3 -3l4 -4l7 -9z" />
    <path d="M6.5 11.5l6 6" />
  </svg>
);

// The canonical combat-tooltip damage sword (13px) — pairs with the red projected
// number to form the ONE damage token used across every combat tooltip: the enemy
// projected hit (decode.jsx .gt-next-dmg) and the potassium tag. currentColor so the
// parent's enemy-red flows in. Distinct from SwordGlyph above (15px, mobile HUD pill).
export const DamageSword = ({ className = 'gt-stat__icon' }) => (
  <svg
    className={className}
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20 4v5l-9 7l-4 4l-3 -3l4 -4l7 -9z" />
    <path d="M6.5 11.5l6 6" />
  </svg>
);

// Permanent sequelae — a scarred heart. Enemy tooltips pair this with the amount
// of HP added to the persistent sequelae ledger, using the HP-bar tag's dark
// maroon readout so permanent injury can never be mistaken for ordinary damage.
export const SequelaeGlyph = ({ className = 'gt-stat__icon' }) => (
  <svg
    className={className}
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M19.5 12.6l-7.5 7.4l-7.5 -7.4a5 5 0 0 1 7.5 -6.6a5 5 0 0 1 7.5 6.6z" />
    <path d="M12 6l-1.8 4l3 1.5l-2.4 3.5l1.2 5" />
  </svg>
);

// Damage taken (cumulative for the round) — a shield absorbing the hit.
export const ShieldGlyph = ({ size = 15, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3" />
  </svg>
);

// Incoming damage (announced for the current round) — a hit landing on you.
export const IncomingGlyph = ({ size = 15, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M12 3v11" />
    <path d="M8 10.5l4 4l4 -4" />
    <path d="M5 19h14" />
  </svg>
);

// HP restored (dialysis healing flow) — a heart.
export const HeartGlyph = ({ size = 15, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M19.5 12.6l-7.5 7.4l-7.5 -7.4a5 5 0 0 1 7.5 -6.6a5 5 0 0 1 7.5 6.6z" />
  </svg>
);
